import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { REPORTS_API } from "./apiRoutes";

interface UseGetInvoiceReportsChartProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getInvoiceReportsChart = async (data: any) =>
  await axiosAuth.post(`${REPORTS_API(data?.communityId)}/chart`, data);

const useGetInvoiceReportsChart = ({
  data,
  queryParams,
}: UseGetInvoiceReportsChartProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["invoice-reports-chart"],
    queryFn: () => getInvoiceReportsChart(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetInvoiceReportsChart;
